import { render } from "./Edit copy.vue?vue&type=template&id=3863abce"
import script from "./Edit copy.vue?vue&type=script&lang=js"
export * from "./Edit copy.vue?vue&type=script&lang=js"

import exportComponent from "/home/mugonat-caaz-omnibox/htdocs/caaz-omnibox.mugonat.com/releases/21/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__